<template>
    <div class="box">
        <Header></Header>

        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">发展历程</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/yj/22.png" alt="">
            </div>

            <Footer></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'History',
	components: {
		Header,
        Footer
	},
	data () {
		return {
            banner: {}
		}
	},

	mounted() {
        this.getData();
	},

	methods: {
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 11
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/companyProfile/developmentHistory.vue